import cx from 'classnames';
import {useInMwEditDesignButtonAbTest} from '~/common/hooks/useInMwEditDesignButtonAbTest';
import {Container} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Container/Container';
import {Envelope} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Envelope/Envelope';
import {Stamp} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Stamp/Stamp';
import {EnvelopeEditor} from './EnvelopeEditor';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

import './Envelope.sass';

export const EnvelopeContainer = ({children, showEnvelopeFront, flipEnvelope}) => {
  const isLargishAndUp = useIsLargishAndUp();
  const isInEditButtonTest = useInMwEditDesignButtonAbTest();

  return (
    <Container
      className={cx('event-create-editor', 'event-create-editor--envelope', {
        'event-create-editor--envelope-front': showEnvelopeFront,
        'event-create-editor--envelope-back': !showEnvelopeFront,
        'onestep-edit-ABTest__editor-wrapper': isInEditButtonTest,
      })}
    >
      {children}
      {showEnvelopeFront ? <Stamp forceShowEnvelope /> : <Envelope forceShowEnvelope />}
      {isLargishAndUp && <EnvelopeEditor flipEnvelope={flipEnvelope} />}
    </Container>
  );
};
